import styled from 'styled-components'

export const CustomerObjectsSectionWrapper = styled.section`
    display: ${props => props.theme.style.display.flex};
    flex: 1;
    flex-direction: ${props => props.theme.style.flexDirection.column};
`

export const ImageWrapper = styled.div`
    height: 10rem;
    width: 12.625rem;
    border-radius: ${props => props.theme.typography.border.radius.xSmall};
    margin-right: ${props => props.theme.spacing.medium};
`

export const SliderContainer = styled.div`
    position: ${props => props.theme.style.position.relative};
    max-width: fit-content;
    overflow: hidden;
`

export const StyledCarouselProvider = styled.div<{ margin?: string }>`
    width: 100%;
    margin: ${({ margin }) => (margin ? margin : 0)};
    li {
        list-style: none;
    }
`

export const StyledSlider = styled.div`
    padding: 0;
    margin: ${props => props.theme.spacing.medium} 0;
`
